<ol *ngIf="layout.crumbs$ | async as crumbs" class="breadcrumbs__container">
  <li *ngFor="let crumb of crumbs; let last = last" [ngClass]="{ 'breadcrumbs__item--active': last }"
    class="breadcrumbs__item">
    <a *ngIf="!last" [routerLink]="crumb.path">{{ crumb.text }}<span class="arrow"
        *ngIf="crumbs.length > 1">></span></a>
    <span *ngIf="last">{{ crumb.text }}</span>
  </li>
</ol>
